// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-loading {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: transparent;
}
.wrapper-loading.full {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(4px);
}
.wrapper-loading.small {
  position: absolute;
  height: 20px;
  width: 20px;
  right: 40px;
}
.wrapper-loading.small .loading {
  width: 20px;
  height: 20px;
  position: relative;
}
.wrapper-loading.small .loading div {
  position: absolute;
  width: 20px;
  height: 20px;
  border: 2px solid var(--sebrae-blue);
  border-top-color: transparent;
  top: 10px;
  left: 10px;
}
.wrapper-loading .loading {
  width: 70px;
  height: 70px;
  position: relative;
}
.wrapper-loading .loading div {
  position: absolute;
  width: 70px;
  height: 70px;
  border: 10px solid var(--sebrae-blue);
  border-top-color: transparent;
  border-radius: 50%;
  animation: loading 1s linear infinite;
  top: 36px;
  left: 36px;
}

@keyframes loading {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/loading/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;AACF;AACE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,8BAAA;EACA,0BAAA;AACJ;AAEE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;AAAJ;AAEI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAAN;AAEM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;AAAR;AAKE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAHJ;AAKI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,6BAAA;EACA,kBAAA;EACA,qCAAA;EACA,SAAA;EACA,UAAA;AAHN;;AAQA;EACE;IACE,6CAAA;EALF;EAOA;IACE,+CAAA;EALF;AACF","sourcesContent":[".wrapper-loading {\n  width: 100%;\n  height: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: transparent;\n\n  &.full {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 99999;\n    background: rgba(0, 0, 0, 0.3);\n    backdrop-filter: blur(4px);\n  }\n\n  &.small {\n    position: absolute;\n    height: 20px;\n    width: 20px;\n    right: 40px;\n\n    .loading {\n      width: 20px;\n      height: 20px;\n      position: relative;\n\n      div {\n        position: absolute;\n        width: 20px;\n        height: 20px;\n        border: 2px solid var(--sebrae-blue);\n        border-top-color: transparent;\n        top: 10px;\n        left: 10px;\n      }\n    }\n  }\n\n  .loading {\n    width: 70px;\n    height: 70px;\n    position: relative;\n\n    div {\n      position: absolute;\n      width: 70px;\n      height: 70px;\n      border: 10px solid var(--sebrae-blue);\n      border-top-color: transparent;\n      border-radius: 50%;\n      animation: loading 1s linear infinite;\n      top: 36px;\n      left: 36px;\n    }\n  }\n}\n\n@keyframes loading {\n  0% {\n    transform: translate(-50%, -50%) rotate(0deg);\n  }\n  100% {\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
